export default "__VITE_PUBLIC_ASSET__dc2fcc1d__"